export default "__VITE_ASSET__BXWmIzSr__"